import userStore from "@/store/modules/userStore";
import {
  BmTaskFilter,
  bmTaskService,
} from "@/app/services/generated/bmtaskService";
import api from "@/app/api";
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import { LocalDateTime } from "@js-joda/core";
import {
  isTaskInToDoSection,
  isTaskOverdue,
} from "@/components/pages/tasks/composables/tasks";
import { EnumTaskStatus } from "@/app/services/generated/enums/enumTaskStatus.generated";
import { reactive, readonly } from "vue";

let timerId = 0;

interface TaskStoreState {
  assignedTasksCount: number;
  assignedOverdueTasksCount: number;
}

const state = reactive<TaskStoreState>({
  assignedTasksCount: 0,
  assignedOverdueTasksCount: 0,
});

async function refresh() {
  if (
    !userStore.isAuthenticatedWithSelectedTenant.value ||
    !userStore.state.user
  ) {
    return;
  }

  const bmTaskFilter = new BmTaskFilter();
  bmTaskFilter.limitAssignedUserIds = [userStore.state.user.id];
  bmTaskFilter.limitStatuses = [EnumTaskStatus.open];

  const { bmTasks } = await bmTaskService.getBmTasksByFilter(
    api.tenantId,
    bmTaskFilter
  );

  const dateTimeNow = LocalDateTime.now(tenantService.getTimezone());

  state.assignedTasksCount = bmTasks.filter((task) =>
    isTaskInToDoSection(task, dateTimeNow)
  ).length;

  state.assignedOverdueTasksCount = bmTasks.filter((task) =>
    isTaskOverdue(task, dateTimeNow)
  ).length;
}

async function startAutoRefresh() {
  if (timerId) {
    clearInterval(timerId);
    timerId = 0;
    state.assignedTasksCount = 0;
    state.assignedOverdueTasksCount = 0;
  }

  await refresh();

  timerId = +setInterval(refresh, 30000);
}

export default {
  state: readonly(state),
  startAutoRefresh,
  refresh,
};
